// extracted by mini-css-extract-plugin
module.exports = {"inputs":"LandingForm_inputs__26kDQ","privacy":"LandingForm_privacy__3uSfc","btn":"LandingForm_btn__1lw9R"};